
export default {
  name: 'ListingFooterProducts',
  props: {
    faq: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      panels: Object.keys(this.faq).map((n) => Number(n)),
      open: false,
      lessCount: 5,
      headers: [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
          // width: '250px',
        },
        {
          text: 'Brand',
          align: 'start',
          value: 'brand.name',
          width: '223px',
        },
        {
          text: 'Collection',
          align: 'start',
          value: 'collection',
          width: '233px',
        },
        {
          text: 'Price',
          align: 'start',
          value: 'price.finalPrice',
          width: '116px',
        },
      ],
    };
  },
  computed: {
    formattedProducts() {
      const panel = this.faq.find((p) => p.__typename === 'productsSeoFAQ');
      if (!Array.isArray(panel?.products)) {
        return [];
      }
      const products = panel.products.map((p) => ({
        ...p, price: { ...p.price, finalPrice: this.formattedPrice(p.price.finalPrice) },
      }));
      return this.open || products.length < this.lessCount ? products : products.slice(0, this.lessCount);
    },
  },
  methods: {
    toggleOpen() {
      this.open = !this.open;
    },
    formattedPrice(number) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
    },
  },
  mounted() {
    this.panels = this.$store.state.user_agent === 'Googlebot' ? Object.keys(this.faq).map((n) => Number(n)) : [];
  },
};
